<template>
    <div class="myHomework myHomeResultPage margin-medium-top commonBackground padding-b-x">
        <div class="title text-l-size border-bottom padding-y delFloat">
            {{title}}
        </div>
        <div class="text-center centerContent">
            <div class="titleS">
                <span class="el-icon-success"></span> 问卷已提交
            </div>
            <div class="aboutSSubject">
                <div class="subject">
                    你选择了 <span>{{groupName}}</span> 三个科目
                </div>
                <div class="margin-top reminder">
                    本次选科作业中，您还有{{frequency}}次机会修改您的选科数据
                    <el-button v-show="frequency>0"
                               @click="$router.push({path:'/electiveAnswer/index',
                               query:{resourceId:resourceId,itemId:itemId,typeId:typeId}})"
                               class="rounded-medium continue"
                               type="primary" size="small">
                        重新选择
                    </el-button>
                </div>
            </div>
            <div class="buttonAlign margin-top">
                <el-button class="rounded-medium lookJl"
                           size="small" @click="$router.push({path:'/sDetail/homeworkDetail',query:{hwId:homeWorkId}})">返回我的作业</el-button>
<!--                <el-button class="rounded-medium continue" type="primary" size="small">继续布置</el-button>-->
            </div>
            <div>

            </div>
        </div>
    </div>
</template>

<script>
    import {getSelectSubjectHomeWorkAnswer} from "../../../config";

    export default {
        name: "resultPage",
        data(){
            return{
                homeWorkId:'',
                title:'',
                itemId:'',
                resourceId:'',
                typeId:'',
                groupName:'',
                //获取选科的次数
                frequency:''
            }
        },
        mounted(){
            if(this.$route.query&&this.$route.query.typeId){
                this.typeId=this.$route.query.typeId;
                this.itemId=this.$route.query.itemId;
                this.resourceId=this.$route.query.resourceId;
                this.getSelectSubjectHomeWorkAnswer();
            }
        },
        methods:{
          //查出结果
            async getSelectSubjectHomeWorkAnswer(){
                let result=await getSelectSubjectHomeWorkAnswer(this.itemId);
                if(result.status){
                    this.groupName=result.data.groupName;
                    this.frequency=result.data.submitCount;
                    this.title=result.data.homeWorkTitle;
                    this.homeWorkId=result.data.homeWorkId;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .myHomeResultPage{
        min-height: 600px;
        .centerContent{
            margin-top:200px;
            margin-bottom: 200px;
            .titleS{
                span{
                    vertical-align: middle;
                    font-size: 29px;
                    color: #67E296;
                }
                font-size:23px;
                margin-bottom: 20px;
            }
            .aboutSSubject{
                .subject{
                    span{
                        color:dodgerblue;
                    }
                }
                .reminder{
                    font-size: 17px;
                    color: orangered;
                }
            }
        }

    }
</style>